module.exports = __webpack_public_path__ + "static/media/viewFullscreenFeedButton.a3fa5707.svg";